export default "__VITE_ASSET__D$78TdC2__"